module.exports = __webpack_public_path__ + "static/media/background-service-page.56043704.png";